import { createStyle } from '@gluestack-style/react';

export const View = createStyle({});
